import React, { SyntheticEvent, useState } from 'react'
import ResultViewer from '../../utils/ResultViewer'
import Swal from 'sweetalert2'
import axios from 'axios'
import BranchEditModal from './BranchEditModal'

function BranchesList() {
  const [itemIdForUpdate, setItemIdForUpdate] = useState('')
  const [refreshFunction, setRefreshFunction] = useState<any>(() => {})
  const filters = [
    {
      name: 'title',
      label: 'Title',
      type: 'text',
    },
  ]
  const convertToTime = (datetime: string) => {
    const date = new Date(datetime)
    const hour = date.getUTCHours()
    const minutes = date.getUTCMinutes()
    return `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
  }
  let clubsHeader = [
    { index: 1, type: 'field', key: 'id', title: 'ID', className: 'min-w-125px' },
    { index: 2, type: 'field', key: 'title', title: 'Title', className: 'min-w-125px' },
    {
      index: 3,
      type: 'field',
      key: 'availableTimeStart',
      title: 'Time Start',
      className: 'min-w-125px',
      postProcess: convertToTime,
    },
    {
      index: 4,
      type: 'field',
      key: 'availableTimeEnd',
      title: 'Time End',
      className: 'min-w-125px',
      postProcess: convertToTime,
    },
    {
      index: 5,
      type: 'field',
      key: 'reservationTimeInterval',
      title: 'Max Reservation Time (Minute)',
      className: 'min-w-125px',
    },
    { index: 6, type: 'field', key: 'actions', title: 'Actions', className: 'min-w-125px' },
  ]
  return (
    <>
      <ResultViewer
        title={'Branches'}
        filter={filters}
        dataUrl={'/admin/branches'}
        editCallback={(id: any, refresh: Function) => {
          setRefreshFunction(() => refresh)
          setItemIdForUpdate(id)
        }}
        deleteCallback={(id: any, refresh: Function) => {
          Swal.fire({
            title: 'Warning',
            html: 'Are you want to delete this branch?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            customClass: {
              confirmButton: 'btn btn-danger',
              cancelButton: 'btn btn-primary',
            },
          }).then((result) => {
            if (result.isConfirmed) {
              axios.delete('admin/branches/' + id).then(() => {
                refresh()
              })
            }
          })
        }}
        actionItems={[
          {
            text: 'Add New Branch',
            class: 'btn btn-sm btn-primary',
            icon: 'fa fa-golf-ball',
            onClick: function (event: SyntheticEvent, refresh: Function) {
              if (itemIdForUpdate !== undefined) {
                setItemIdForUpdate('add')
                setRefreshFunction(() => refresh)
              }
            },
          },
        ]}
        header={clubsHeader}
      />
      {itemIdForUpdate !== '' ? (
        <BranchEditModal
          show={itemIdForUpdate !== ''}
          itemIdForUpdate={itemIdForUpdate}
          onClose={() => {
            setItemIdForUpdate('')
          }}
          refresh={(itemId: any) => {
            if (itemId !== undefined) {
              setItemIdForUpdate(itemId)
            }
            refreshFunction()
          }}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default BranchesList
